import { formatDuration } from './formatDuration';
import { getDateTimeDiff } from './getDateTimeDiff';

import { LUXON_FORMAT } from '../constants';

export function getFormattedDateTimeDiff(startISO, endISO, format = LUXON_FORMAT.DURATION) {
  return formatDuration(getDateTimeDiff(startISO, endISO), format);
}
